/* @flow */
import * as React from 'react';

import {InfoIcon} from '../icon';

import './help-styles.module.css';

type Props = {
    onClick: (e: SyntheticMouseEvent<>) => void,
    variant?: 'error' | 'green' | 'blue',
    size?: number,
    noPadding?: boolean,
};

export const HelpButton = React.forwardRef<Props, HTMLButtonElement>((props: Props, ref) => {
    const getStyleName = () => {
        if (props.variant === 'error') {
            return 'help-icon--error';
        }

        if (props.variant === 'green') {
            return 'help-icon--green';
        }

        if (props.variant === 'blue') {
            return 'help-icon--blue';
        }

        if (props.noPadding) {
            return 'help-icon--no-padding';
        }

        return 'help-icon';
    };

    return (
        <button styleName={getStyleName()} type='button' onClick={props.onClick} ref={ref}>
            <InfoIcon
                wrapWithDiv={false}
                size={props.size ? props.size : 16}
                useCurrentColor={true}
            />
        </button>
    );
});
